export default {
  init() {
    const url = document.location.href;
    const copyBtn = document.querySelector('.js-copy-url');

    if (copyBtn) {
      const { copiedText } = copyBtn.dataset;

      copyBtn.addEventListener('click', () => {
        // Create a "hidden" input
        const aux = document.createElement('input');

        // Assign it the value of the specified element
        aux.setAttribute('value', url);

        // Append it to the body
        document.body.appendChild(aux);

        // Highlight its content
        aux.select();

        // Copy the highlighted text
        document.execCommand('copy');

        // Remove it from the body
        document.body.removeChild(aux);

        copyBtn.querySelector(
          '.sharing-controls__label'
        ).innerHTML = copiedText;
      });
    }
  }
};
